import { generateCaptchaTokenResult as _generateCaptchaTokenResult } from '@worldcoo/ui/lib/captcha';
import { getRuntimeRecaptchaSiteKey } from './shared';

export function generateCaptchaTokenResult() {
	// The runtime key for both load and execute, so one artifact serves every stage; the base impl self-loads
	// api.js, so the donate flow works without a mounted form (TEC-3418).
	return _generateCaptchaTokenResult(getRuntimeRecaptchaSiteKey());
}
